import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const ContactInfo = () => (
  <div className="mt-10 space-y-5">
    <a
      href="mailto:trustedhandsnz@gmail.com"
      className="flex items-center gap-4 py-4 border-b border-[#d9d0c1] hover:text-[#a4514a] transition-colors"
    >
      <Mail size={18} className="text-[#a4514a]" strokeWidth={1.6} />
      <span className="text-[15px]">trustedhandsnz@gmail.com</span>
    </a>
    <a
      href="tel:+642040274459"
      className="flex items-center gap-4 py-4 border-b border-[#d9d0c1] hover:text-[#a4514a] transition-colors"
    >
      <Phone size={18} className="text-[#a4514a]" strokeWidth={1.6} />
      <span className="text-[15px]">020 4027 4459</span>
    </a>
    <div className="flex items-center gap-4 py-4 border-b border-[#d9d0c1]">
      <MapPin size={18} className="text-[#a4514a]" strokeWidth={1.6} />
      <span className="text-[15px]">Tauranga, Bay of Plenty</span>
    </div>
  </div>
);

export default ContactInfo;
